// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label-align{margin-bottom:1rem}.label-align>span{color:#1b232e;font-weight:600;width:230px}@media screen and (max-width: 544px){.label-align>span{width:200px}}@media screen and (min-width: 992px){.label-align>span{width:180px}}@media screen and (min-width: 1200px){.label-align>span{width:230px}}\n", ""]);
// Exports
module.exports = exports;
